import { Card, Text } from "@/components/ui"
import type { PrizeDraw } from "@/domain/marketing/api"
import { PrizeArt } from "./PrizeArt"
import { PrizeRedeemCard } from "./prize-redeem/PrizeRedeemCard"

type PrizeResultProps = {
  draw: PrizeDraw
  headline?: boolean
  onLeave: () => void
}

/** The result card that takes the place of the game's button: a gentle miss, or the won prize and how to spend it (see {@link PrizeRedeemCard}). */
export function PrizeResult({ draw, headline = true, onLeave }: PrizeResultProps) {
  if (draw.won) return <PrizeRedeemCard draw={draw} headline={headline} onLeave={onLeave} />
  return (
    <Card variant="game" radius="sheet" className="flex w-full flex-col items-stretch gap-3 text-center">
      {headline ? (
        <div className="flex flex-col items-center gap-1">
          <PrizeArt soft label="" size={40} />
          <Text size="xl" family="game-display">
            Não foi dessa vez
          </Text>
        </div>
      ) : null}
      <Text size="sm" tone="muted">
        Volte em breve para tentar de novo.
      </Text>
    </Card>
  )
}
